import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OperatorFunction, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { BehaviourModelSetTransformer } from '../coaching-tags/models/behaviour.coaching.model';
import { MetricModelSetTransformer } from '../coaching-tags/models/metric.coaching.model';
import { SubBehaviourModelSetTransformer } from '../coaching-tags/models/subbehaviour.coaching.model';
import { catchErrorLogRet, mapRetrieve } from '../common/rest.operators';

import { LookupBox } from './general';

@Injectable()
export class NextCoachingService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveLookupBox<T>(): OperatorFunction<T, LookupBox> {
        return pipe(
            switchMap(() =>
                this._http.get(
                    `${this._appConfig.API_ENDPOINTS.COACHING}/coaching/lookupbox`,
                ),
            ),
            mapRetrieve(),
            map((e) => {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return {
                    behaviours: new BehaviourModelSetTransformer().transform(
                        e.behaviours,
                    ),
                    subBehaviours:
                        new SubBehaviourModelSetTransformer().transform(
                            e.subBehaviours,
                        ),
                    metrics: new MetricModelSetTransformer().transform(
                        e.metrics,
                    ),
                } as LookupBox;
            }),
            catchErrorLogRet({}),
        );
    }
}
